import { render, staticRenderFns } from "./FabButton.vue?vue&type=template&id=004bf005"
import script from "./FabButton.vue?vue&type=script&lang=js"
export * from "./FabButton.vue?vue&type=script&lang=js"
import style0 from "./FabButton.vue?vue&type=style&index=0&id=004bf005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports